import {GetterTree, MutationTree, ActionTree} from 'vuex'
import {FlashState} from '@/store/types'

type FlashGetter = GetterTree<FlashState, any>
type FlashMutation = MutationTree<FlashState>
type FlashAction = ActionTree<FlashState, any>

const state: FlashState = {
  flash: false,
  message: '',
  type: 1,
}

const getters: FlashGetter = {
  flash: (state) => state.flash,
  message: (state) => state.message,
  type: (state) => state.type,
}

const mutations: FlashMutation = {
  setFlashMessage: (state, payload) => {
    state.flash = payload.flash ? payload.flash : true
    state.message = payload.message ? payload.message : ''
    state.type = payload.type ? payload.type : 1
  },
  setMessage: (state, payload) => {
    state.message = payload
  },
  setType: (state, payload) => {
    state.type = payload
  },
}

const actions: FlashAction = {

}

export default {
  state,
  getters,
  mutations,
  actions,
}
